// base
import { forwardRef, useCallback, useEffect, useState } from 'react';

// modules
import { userApi } from 'modules/user/apis/user.api';

// style
import './style.scss';
import {
  StyledGsCard,
  StyledGsCardContent,
  StyledGsCardImageBox,
  StyledSamsungCard,
  StyledSamsungCardContent,
  StyledSamsungCardImageBox,
  StyledSamsungCardUserName
} from './style';

// modules
import { type UserCombinedInfo, type UserDetailInfo } from 'modules';

// services
import { usePkgCheck } from 'hooks';

// constants
import { PKG_1, PKG_2, PKG_4 } from 'constants/const';

// utils
import { formattedDateEnShortAndHy } from 'utils';

interface CardToPrintProps {
  userDetail: UserCombinedInfo & UserDetailInfo;
}

export const CardToPrint = forwardRef<HTMLDivElement, CardToPrintProps>(({ userDetail }, ref) => {
  const [image, setImage] = useState('');
  const { pkgNo } = usePkgCheck();
  const [userNameExtraSize, setUserNameExtraSize] = useState(0);

  const getFileImage = useCallback(async () => {
    if (!userDetail) return;

    try {
      if (userDetail.userFileId) {
        const img = await userApi.getUserDownloadAPI(userDetail.userFileId);
        setImage(img);
      }
    } catch (e) {
      console.error(e);
    }
  }, [userDetail]);

  useEffect(() => {
    getFileImage();
  }, [getFileImage]);

  useEffect(() => {
    if (userDetail.userName) {
      const userName = userDetail.userName;

      if (userName.length > 20 && userName.split(' ').length >= 5) {
      }

      //
      else if (userName.length > 30) {
      }

      //
      else {
        setUserNameExtraSize(12);
      }
    }
  }, [userDetail.userName]);

  switch (pkgNo) {
    case PKG_2:
      return (
        <StyledGsCard ref={ref}>
          <StyledGsCardImageBox>
            <img src={image} alt="ssp-card-image" />
          </StyledGsCardImageBox>
          <StyledGsCardContent top={575}>{userDetail.companyName || ''}</StyledGsCardContent>
          <StyledGsCardContent top={638}>{userDetail.designationName || ''}</StyledGsCardContent>
          <StyledGsCardContent top={691 + userNameExtraSize} style={{ fontSize: '24px' }}>
            {userDetail.userName || ''}
          </StyledGsCardContent>
          <StyledGsCardContent top={755}>{userDetail.nationName || ''}</StyledGsCardContent>
          <StyledGsCardContent top={825}>
            {formattedDateEnShortAndHy(userDetail.birthDate)}
          </StyledGsCardContent>
          <StyledGsCardContent top={883}>{userDetail.bloodType || ''}</StyledGsCardContent>
        </StyledGsCard>
      );

    case PKG_1:
    case PKG_4:
      return (
        <StyledSamsungCard ref={ref}>
          <StyledSamsungCardImageBox>
            <img src={image} alt="ssp-card-image" />
          </StyledSamsungCardImageBox>

          <StyledSamsungCardUserName>
            <div>{userDetail.userName || ''}</div>
          </StyledSamsungCardUserName>

          <StyledSamsungCardContent>{''}</StyledSamsungCardContent>
          <StyledSamsungCardContent>{userDetail.companyName || ''}</StyledSamsungCardContent>
          <StyledSamsungCardContent>{userDetail.iqamaNo || ''}</StyledSamsungCardContent>
          <StyledSamsungCardContent>{userDetail.designationName || ''}</StyledSamsungCardContent>
          <StyledSamsungCardContent>
            {formattedDateEnShortAndHy(userDetail.birthDate)}
          </StyledSamsungCardContent>
          <StyledSamsungCardContent>{userDetail.nationName || ''}</StyledSamsungCardContent>
          <StyledSamsungCardContent>{userDetail.bloodType || ''}</StyledSamsungCardContent>
        </StyledSamsungCard>
      );
  }
});

CardToPrint.displayName = 'CardToPrint';
